import notifier from '@albert-io/notifier';
import apolloClient from 'apollo/client';
import constants from 'client/constants';

import {SubjectViewDocument} from './SubjectView.queries.generated';

type RouterState = {
  params: {slug: string};
  location: {pathname: string};
};

/**
 * Route `onEnter` hook for the subject-page route.
 * Fetches the subject via GQL to determine guide types and redirects to the
 * correct tab (free-response or assessments) when practice guides are absent.
 * Also primes the Apollo cache so SubjectView gets an instant cache hit.
 */
export async function subjectPageOnEnter(
  nextState: RouterState,
  replace: (path: string) => void,
  callback: () => void
) {
  const {slug} = nextState.params;
  let redirect: string | undefined;
  const routes = {
    assessment: `/${slug}/assessments`,
    free_response: `/${slug}/free-response`
  };

  try {
    const {data} = await apolloClient.query({
      query: SubjectViewDocument,
      variables: {slug}
    });
    const subject = data?.subjects?.results?.[0];
    const guideTypes = subject?.guides?.map((g: {type: string}) => g.type) ?? [];

    if (
      !nextState.location.pathname.includes(`/${slug}/overview`) &&
      !guideTypes.includes(constants.GUIDE_TYPES.PRACTICE)
    ) {
      if (guideTypes.includes(constants.GUIDE_TYPES.FREE_RESPONSE)) {
        redirect = routes.free_response;
      } else if (guideTypes.includes(constants.GUIDE_TYPES.ASSESSMENT)) {
        redirect = routes.assessment;
      }
    }
  } catch (err) {
    notifier.notify(err, {severity: 'error'});
  }

  const shouldRedirect =
    !!redirect &&
    !nextState.location.pathname.includes(redirect) &&
    !nextState.location.pathname.includes(`/${slug}/overview`);

  if (shouldRedirect) {
    replace(redirect!);
  }
  callback();
}
